import React from "react";
import { Button, Grid, Stack } from "@mui/material";
import Icon from "src/components/icon";
import styled from "styled-components";
import Link from "src/components/link";
import { getNotionRedirectUrl } from "src/scenes/integrations/utils";
import notion from "../../../assets/icons/notion";

const H1 = styled.h1`
    font-size: 22px;
    margin: 0;
    font-weight: normal;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const H2 = styled.h2`
    font-size: 14px;
    font-weight: normal;
    margin: 0;
    color: ${({ theme }) => theme.palette.primary.main};
`;

const P = styled.h2`
    font-size: 12px;
    font-weight: normal;
    margin: 0;
    ${({ theme }) => theme.breakpoints.up("sm")} {
        width: 50%;
    }
    color: ${({ theme }) => theme.palette.secondary.main};
`;

const PermissionsIcon = styled(Icon)`
    background-color: #fff;
    border-radius: 16px;
    padding: 24px 12px 24px 12px;
    margin: 32px 0 32px 0;
`;

const ContactPlaceholder =
    "In case of any inquiry regarding software permissions, please do not hesitate to ";

const PermissionsNotion = () => {
    const handleClick = () => {
        window.location.replace(
            `https://api.notion.com/v1/oauth/authorize?&client_id=${
                process.env.NOTION_CLIENT_ID
            }&response_type=code&owner=user&redirect_uri=${getNotionRedirectUrl()}`
        );
    };
    return (
        <Grid container justifyContent="center" mb={4}>
            <Stack
                direction="column"
                alignItems="flex-start"
                style={{ height: "100%", width: "70%" }}
            >
                <H1>Notion Integration</H1>
                <H2>How adadot handles your Notion data</H2>
                <PermissionsIcon svg={notion} width="100px" height="127" />
                <P style={{ marginTop: "12px" }}>
                    {ContactPlaceholder}
                    <Link to="/upgrade/inquiry">contact us</Link>
                </P>
                <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    onClick={handleClick}
                    style={{ width: "102px", marginTop: "32px" }}
                >
                    Continue
                </Button>
            </Stack>
        </Grid>
    );
};

export default PermissionsNotion;
